<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useBadgesStore } from "#/store/badges";
import { useThemeStore } from "#/store/theme";
import type { BadgeShape } from "#/utils/badges";
import BadgeItem from "./BadgeItem.vue";

interface Props {
	badges?: string[] | null;
	placement?: "photo" | "inline";
	size?: "md" | "sm";
	limit?: number | null;
}

const props = withDefaults(defineProps<Props>(), { placement: "photo", size: "md", limit: null });

const themeStore = useThemeStore();
const badgesStore = useBadgesStore();

const isEnabled = computed(() => themeStore.data?.show_badges !== false);
const defaultShape = computed<BadgeShape>(() => themeStore.data?.badge_shape_default as BadgeShape || "pill");
const visibleBadges = computed(() => (isEnabled.value ? badgesStore.resolve(props.badges, props.limit) : []));

onMounted(() => {
	if (props.badges?.length) void badgesStore.ensureLoaded();
});
</script>

<template>
	<div v-if="visibleBadges.length" class="product_badges" :class="[`product_badges_${placement}`, `product_badges_${size}`]">
		<BadgeItem v-for="badge in visibleBadges" :key="badge.key" :badge="badge" :defaultShape="defaultShape" :size="size" />
	</div>
</template>

<style scoped lang="scss">
  @use './productBadges.scss';
</style>
